export default function Footer() {
  return (
    <footer data-testid="footer" className="bg-emerald-950 text-emerald-50 py-14">
      <div className="mx-auto max-w-7xl px-6 lg:px-10 grid grid-cols-1 md:grid-cols-3 gap-10">
        <div>
          <div className="font-[Cormorant_Garamond] text-3xl text-white leading-tight">
            Freedom In Me<br />Business Showers
          </div>
          <p className="font-[Outfit] text-sm text-emerald-100/75 mt-4 leading-relaxed">
            A national small business accelerator activating people, resources and capital to equip entrepreneurs and youth.
          </p>
        </div>
        <div>
          <div className="text-[11px] uppercase tracking-[0.3em] text-amber-300 font-[Outfit] font-bold">Visit</div>
          <ul className="mt-4 space-y-2 font-[Outfit] text-sm">
            <li><a className="hover:text-amber-300" href="https://www.businessshowers.org" target="_blank" rel="noreferrer">businessshowers.org</a></li>
            <li><a className="hover:text-amber-300" href="https://www.businessshowers.org/contest" target="_blank" rel="noreferrer">Vote at /contest</a></li>
            <li><a className="hover:text-amber-300" href="https://www.businessshowers.org/about" target="_blank" rel="noreferrer">About FIM</a></li>
            <li><a className="hover:text-amber-300" href="https://unitedwaygreaterclt.org/" target="_blank" rel="noreferrer">United Way of Greater Charlotte</a></li>
          </ul>
        </div>
        <div>
          <div className="text-[11px] uppercase tracking-[0.3em] text-amber-300 font-[Outfit] font-bold">Contact</div>
          <div className="mt-4 font-[Outfit] text-sm space-y-1">
            <div>1235 East Blvd STE C1 PMB 1169</div>
            <div>Charlotte, NC 28203</div>
            <div><a className="hover:text-amber-200" href="mailto:admin@itsthefreedominme.com">admin@itsthefreedominme.com</a></div>
            <div>980-292-1622</div>
          </div>
        </div>
      </div>
      <div className="mx-auto max-w-7xl px-6 lg:px-10 mt-10 pt-6 border-t border-white/10 text-xs font-[Outfit] text-emerald-100/60 flex flex-wrap justify-between gap-3">
        <span>© {new Date().getFullYear()} Freedom In Me Business Showers · 501(c)(3)</span>
        <a href="/admin" className="hover:text-amber-200">Staff Login</a>
      </div>
    </footer>
  );
}
